/**
 * @file 路由配置
 */


 const mall = {
    path: 'mall',
    name: 'mall',
    meta: {
        requiresAuth: true,
        label: '数据商城发布'
    },
    component(resolve) {
        require.ensure([], () => resolve(require('@/modules/publish/mall')));
    }
};
export default {
    path: '/publish',
    name: 'publish',
    redirect: '/publish/mall',
    icon: 'el-icon-s-custom',
    meta: {
        requiresAuth: true,
        label: '数据发布'
    },
    component(resolve) {
        require.ensure([], () => resolve(require('@/modules/publish')));
    },
    children: [mall]
};
